module.exports = __webpack_public_path__ + "static/media/SourceSansPro-Regular.b2a45254.woff2";


//////////////////
// WEBPACK FOOTER
// ./src/assets/fonts/SourceSansPro-Regular.woff2
// module id = 332
// module chunks = 3